import axios from 'axios'

import { defineNuxtPlugin } from '#app'
import { createApiService } from '@/api'
import { Mode } from '~/types/main'

// TODO: Написать тесты на все окружения
export default defineNuxtPlugin(
  ({ $config, $cityPrefix, $sentryCaptureException }) => {
    const { API_BASE_URL, API_BASE_URL_KG, MODE, BRAND_UUID, VARITI_TOKEN } =
      $config.public
    const { host } = useRequestURL()
    /*
    Приходится указывать принудительно тип
    MODE, т.к из переменных окружения его не передать
  */
    const API_URL = getApiUrl(API_BASE_URL, API_BASE_URL_KG, MODE as Mode, host)

    const baseURL = `${API_URL}/v3/${BRAND_UUID}/`

    const baseAxios = axios.create({
      baseURL,
      xsrfCookieName: 'csrftoken2',
      xsrfHeaderName: 'X-CSRFTOKEN',
      withCredentials: true,
      headers: { ...getAxiosGlobalHeader({ varitiToken: VARITI_TOKEN }) },
    })

    // мокаем sentry для axios
    const sentry = {
      captureException: (error: unknown) => $sentryCaptureException(error),
    }

    const apiService = createApiService({
      sentry,
      axios: baseAxios,
      city: $cityPrefix as string,
      hostname: host,
    })

    return {
      provide: {
        apiService,
        axios: baseAxios,
      },
    }
  },
)
